import axios from 'axios';
import axiosRetry from 'axios-retry';

import { API_BASE_URL } from './config';
import { apiKeyHeaders } from './api-key-headers';

// Configure axios defaults
axios.defaults.baseURL = API_BASE_URL;

// Configure axios retry
axiosRetry(axios, {
  retries: 3,
  shouldResetTimeout: true,
  retryCondition: (error: any) => {
    return axiosRetry.isRetryableError(error) && error.config.method === 'get';
  },
});

// Add request interceptor to include user info in headers
axios.interceptors.request.use(
  (config) => {
    // Các API được gate `createApiKeyGate` phía server (crawler + `/api/bld-reports/config`) cần
    // header `x-api-key` (từ `VITE_EMAIL_CRAWLER_API_KEY`) — xem api-key-headers.ts.
    Object.assign(config.headers, apiKeyHeaders(config.url));

    try {
      // Get user info from localStorage
      const dataLogin: any = localStorage.getItem('dataLogin');
      if (dataLogin) {
        let parsed: any;
        try {
          parsed = JSON.parse(dataLogin);
        } catch (error) {
          console.log('🚀 ~ axios.ts:27 ~ error:', error);
        }
        const user = parsed?.user;

        if (user) {
          // Add username and user_id to headers
          config.headers['x-username'] = user.username || 'unknown';
          config.headers['x-user-id'] = user.id || '';
        }
      }
    } catch (error) {
      console.error('Error adding user info to request headers:', error);
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export default axios;
